export const checkInFormModel = ({
                                     barcode,
                                     copyBarcode,
                                     copyShelfLocation,
                                     defaultBarcode,
                                     shelfLocation,
                                     status,
                                 }: Record<string, any> = {}) => ({
    barcode: barcode || defaultBarcode,
    copyBarcode: copyBarcode || defaultBarcode,
    copyShelfLocation,
    shelfLocation,
    status,
});

export const checkInCopyDetailsModel = ({
                                            copyBarcode,
                                            copyShelfLocation,
                                            orderId,
                                        }: Record<string, any> = {}) => ({
    copyBarcode,
    shelfLocation: copyShelfLocation,
    orderId,
});

export const checkInVolumeDetailsModel = ({
                                              barcode,
                                              shelfLocation,
                                              status,
                                              orderId
                                          }: Record<string, any> = {}) => ({
    volume: volumeDetailsModel({barcode, shelfLocation, status}),
    orderId,
});


export const volumeDetailsModel = ({
                                       barcode = ``,
                                       barCode = ``,
                                       copy,
                                       shelfLocation = ``,
                                       status = ``,
                                       id = ``,
                                   }: Record<string, any> = {}) => ({
    barcode: barcode || barCode,
    copy,
    shelfLocation,
    status,
    id,
});